import { gql, useQuery } from '@apollo/client'
import { useTokens } from '@reservoir0x/reservoir-kit-ui'
import LoadingSpinner from 'components/common/LoadingSpinner'
import LoreMarkdownRenderer from 'components/lore/LoreMarkdownRenderer'
import { Box, Button, Flex } from 'components/primitives'
import Text from 'components/primitives/Text'
import { useRouter } from 'next/router'

type Props = {
  token: ReturnType<typeof useTokens>['data'][0] | null
}

const LORE_QUERY = gql`
  query Query($contract: citext, $tokenId: Int) {
    PaginatedLore(
      order_by: { globalpage: asc }
      where: {
        tokenContract: { _eq: $contract }
        tokenId: { _eq: $tokenId }
        isArchivedByHolder: { _neq: true }
        nsfw: { _neq: true }
      }
    ) {
      markdownText
    }
  }
`

export const LoreTab = ({ token }: Props) => {
  const router = useRouter()

  const { data, loading } = useQuery(LORE_QUERY, {
    variables: {
      contract: token?.token?.contract,
      tokenId: token?.token?.tokenId,
    },
    fetchPolicy: 'no-cache',
  })
  return (
    <div>
      {loading && (
        <Flex align="center" justify="center" css={{ py: '$5' }}>
          <LoadingSpinner />
        </Flex>
      )}
      {((data && data.PaginatedLore.length === 0) || (!data && !loading)) && (
        <Flex
          direction="column"
          align={'center'}
          style={{ textAlign: 'center' }}
        >
          <Text>No lore found for this token.</Text>
          {/* <Box style={{ height: '20px' }} />
          <Button
            onClick={() => {
              router.push('https://www.forgottenrunes.com/lore')
            }}
          >
            Go to Book of Lore
          </Button> */}
        </Flex>
      )}
      {data &&
        data.PaginatedLore.map((loreEntry: any) => (
          <>
            <LoreMarkdownRenderer markdown={loreEntry.markdownText} />
            {/* nice styled line break between entries */}
            <div
              style={{
                height: '1px',
                backgroundColor: 'rgba(255,255,255,0.1)',
                margin: '20px 0',
              }}
            ></div>
          </>
        ))}
      {/* {data && data.PaginatedLore.length > 0 && (
        <>
          <Box style={{ height: '20px' }} />
          <Button
            onClick={() => {
              router.push('https://www.forgottenrunes.com/lore')
            }}
          >
            Add more entries in the Book of Lore
          </Button>
        </>
      )} */}
    </div>
  )
}
